import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ReceptionShell } from './shell';

import NotFoundPage from '../routes/notFound';

const ReceptionRoutes: React.FC = () => (
  <Switch>
    <Route path="/reception" component={ReceptionShell} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default ReceptionRoutes;
